export const FEATURE_FLAG_SORTS = {
    RECENT: 'recent',
    ALPHABETICAL: 'alphabetical',
} as const

export type FeatureFlagSort = (typeof FEATURE_FLAG_SORTS)[keyof typeof FEATURE_FLAG_SORTS]

export type UserFeatureFlag = {
    name: string
    created_at: string
    enabled: boolean
}

const featureTimestamp = (feature: UserFeatureFlag) => {
    const timestamp = Date.parse(feature.created_at)
    return Number.isNaN(timestamp) ? 0 : timestamp
}

export function filterAndSortFeatureFlags(
    features: UserFeatureFlag[],
    query: string,
    sort: FeatureFlagSort,
) {
    const normalizedQuery = query.trim().toLocaleLowerCase()
    const filtered = normalizedQuery
        ? features.filter(feature => feature.name.toLocaleLowerCase().includes(normalizedQuery))
        : [...features]

    return filtered.sort((left, right) => {
        const alphabetical = left.name.localeCompare(right.name)
        if (sort === FEATURE_FLAG_SORTS.ALPHABETICAL) return alphabetical

        return featureTimestamp(right) - featureTimestamp(left) || alphabetical
    })
}
